import { z } from 'zod';
import { passwordSchema } from './auth.js';
import { idSchema, nameSchema } from './common.js';
export const setPasswordInputSchema = z.strictObject({
    password: passwordSchema,
});
export const renameHouseholdInputSchema = z.strictObject({
    name: nameSchema,
});
/**
 * Pours one household into another: its members and all its data move, and the
 * emptied household is removed.
 *
 * This is what "share everything between these people" means concretely — one
 * pool, one set of names, no ambiguity about who owns what.
 */
export const mergeHouseholdsInputSchema = z.strictObject({
    intoHouseholdId: idSchema,
});
export const impersonateInputSchema = z.strictObject({
    userId: idSchema,
});
//# sourceMappingURL=admin.js.map